export default "__VITE_ASSET__d5408853__"